module.exports = __webpack_public_path__ + "img/continue.7429b264.png";